import React, { useState, useEffect } from 'react'
import { Combo } from 'components'
import { fetchUrl } from 'modules/util/functions'

const TrabajoCombo = (props) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        fetchUrl("/query/getTrabajos", "get", {}, {
            success: (r) => {
                setItems(r.data.items.map(x => ({
                    value: x.idTrabajo,
                    label: x.label
                })));
            }
        }, { block: false });
    }, []);

    return (
        <Combo
            {...props}
            items={items} />
    )
}

export default TrabajoCombo;

TrabajoCombo.defaultProps = {
    formControl: true,
    formManaged: false
};